// import React from 'react';
// import './ServiceDetail.css';

// function DataMining() {
//   return (
//     <div className="service-detail">
//       <h2>Data Mining</h2>

//       <section>
//         <h3>What is Data Mining?</h3>
//         <p>
//           Data Mining is the process of discovering patterns, correlations, anomalies, and useful information from large datasets using statistical, machine learning, and database techniques.
//         </p>
//       </section>

//       <section>
//         <h3>Why is Data Mining Important?</h3>
//         <ul>
//           <li>Transforms raw data into actionable insights</li>
//           <li>Improves business decision-making</li>
//           <li>Enhances marketing, fraud detection, and operations</li>
//         </ul>
//       </section>

//       <section>
//         <h3>Applications of Data Mining</h3>
//         <ul>
//           <li>Customer segmentation and profiling</li>
//           <li>Market basket analysis</li>
//           <li>Fraud detection and risk management</li>
//           <li>Predictive analytics in finance and healthcare</li>
//         </ul>
//       </section>

//       <section>
//         <h3>Techniques Used</h3>
//         <ul>
//           <li>Classification and Regression</li>
//           <li>Clustering (e.g., K-means, DBSCAN)</li>
//           <li>Association Rule Mining (e.g., Apriori algorithm)</li>
//           <li>Decision Trees and Neural Networks</li>
//         </ul>
//       </section>

//       <section>
//         <h3>Our Services Include</h3>
//         <ul>
//           <li>End-to-end data mining solutions tailored to your business</li>
//           <li>Custom dashboards and visualizations</li>
//           <li>Scalable models using Python, R, and modern frameworks</li>
//           <li>Consulting, implementation, and support</li>
//         </ul>
//       </section>
//     </div>
//   );
// }

// export default DataMining;





import React from 'react';
import { motion } from 'framer-motion';
import './DataMining.css';
//import webIcon from '../assets/web-data.png';
//import socialIcon from '../assets/social-data.png';
//import leadIcon from '../assets/lead-data.png';
//import imageIcon from '../assets/image-data.png';

function DataMining() {
  return (
    <div className="datamining-page">
      {/* Hero Section */}
      <div className="hero-section">
        <h1>Data Mining Services</h1>
        <p>Scalable, Reliable, And Accurate Web Data Mining Services</p>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        {[
          { label: "Years of Experience", value: "28+" },
          { label: "FTEs across Geographies", value: "500+" },
          { label: "Data Security", value: "100%" },
          { label: "Accuracy Achieved", value: "99%+" },
          { label: "Availability", value: "24×7" },
        ].map((stat, index) => (
          <motion.div
            className="stat-card"
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <h3>{stat.value}</h3>
            <p>{stat.label}</p>
          </motion.div>
        ))}
      </div>

      {/* Description */}
      <div className="description">
        <h2>Get Access to a Wide Range of Data Mining Solutions</h2>
        <p>
          Outsource Data Mining Services to gain faster access to business-critical data and to drive faster decision-making.
        </p>
        <p>
          We leverage the latest tools and techniques to forecast trends, uncover patterns, and gather market insights for smarter strategies and growth.
        </p>
      </div>

      {/* Service Cards */}
      <div className="service-grid">
        {[
          {
            title: "Web Data Mining",
            desc: "Automated/manual data scrapping from websites, directories, portals, and more.",
            //icon: webIcon
          },
          {
            title: "Social Media Data Mining",
            desc: "Analyze billions of posts to gain customer, competitor, and market insights.",
            //icon: socialIcon
          },
          {
            title: "Lead Data Mining",
            desc: "Extract and compile optimized leads from multiple sources including job boards and directories.",
            //icon: leadIcon
          },
          {
            title: "Image Data Mining",
            desc: "Retrieve and analyze images from varied datasets like real estate or medical imagery.",
            //icon: imageIcon
          }
        ].map((service, index) => (
          <motion.div
            className="service-card"
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.2 }}
          >
            <img src={service.icon} alt={service.title} />
            <h4>{service.title}</h4>
            <p>{service.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default DataMining;
